import { SWRConfiguration } from "swr";
import useSWRImmutable from "swr/immutable";

export interface Customer {
  id: string;
  name: string;
  nyceId: string;
  clusterId: string;
  cutOffTime: string;
  availableDates: {
    dateType: string;
    firstAvailableDate: string;
    lastAvailableDate: string;
  }[];
  forecast: {
    orderType: string;
    enabled: boolean;
    deadline: string;
  }[];
}

// The customer list doesn't change during a session, so it is fetched once and
// every later mount reads it from the SWR cache.
export const useCustomers = (config?: SWRConfiguration<Customer[]>) =>
  useSWRImmutable<Customer[]>("/customers", config);
